<template>
  <div class="page" @mousemove="onMove" @mouseleave="mx=0;my=0">
    <div class="amb a1"></div><div class="amb a2"></div><div class="amb a3"></div>
    <div class="dots"></div><div class="ring r1"></div><div class="ring r2"></div><div class="bg-grid"></div>
    <div class="nav-bar" :style="[navElastic, navTiltStyle]" @mousemove="navTilt" @mouseleave="navTiltReset">
      <el-image class="nav-logo" @click="backHome" :src="logo" />
      <a class="nav-f" href="https://www.osredm.com/">首页</a>
      <a class="nav-s" href="https://www.osredm.com/explore/all">开源项目</a>
      <a class="nav-s" href="https://www.osredm.com/task">创客空间</a>
      <a class="nav-s" href="https://fc.osredm.com/competitions">开放竞赛</a>
      <a class="nav-s" href="https://fc.osredm.com/forums">论坛交流</a>
      <router-link to="/" class="nav-back">← 返回工具集</router-link>
    </div>

    <div class="hero">
      <img class="hero-icon" src="../assets/icon/json.svg" alt=""/>
      <h1>JSON 代码格式化工具</h1>
      <p>基于 Vue-Json-Viewer 插件，支持格式化与树形结构可视化浏览</p>
    </div>

    <div class="main">
      <div class="card">
        <div class="panels">
          <div class="panel">
            <div class="panel-head"><span class="ph-dot"></span>待格式化 JSON</div>
            <el-input v-model="nativeCode" type="textarea" :rows="16" placeholder="在此粘贴 JSON 代码..." />
          </div>
          <div class="panel">
            <div class="panel-head"><span class="ph-dot done"></span>格式化结果</div>
            <json-viewer :value="formatCode" copyable style="min-height:390px" />
          </div>
        </div>
        <div class="actions">
          <el-button @click="Format" type="primary" round class="btn-main">格式化代码</el-button>
        </div>
      </div>
    </div>

    <footer class="foot">
      <div class="foot-glow"></div>
      <div class="foot-top">
        <img class="foot-logo" :src="logoWhite" alt="OSREDM" />
        <p class="foot-desc">面向开源生态的一站式在线工具平台</p>
        <div class="foot-links">
          <router-link to="/">返回工具集</router-link>
          <router-link to="/cssTools">CSS 格式化</router-link>
          <router-link to="/xmlTools">XML 格式化</router-link>
          <router-link to="/uuidTools">UUID 生成器</router-link>
          <router-link to="/encryptionTool">加解密工具</router-link>
          <a href="https://www.osredm.com/explore/all">开源项目</a>
        </div>
      </div>
      <div class="foot-bar">
        <span>© 2026 OSREDM.COM</span>
        <a href="https://www.osredm.com/">平台首页</a>
        <a href="https://fc.osredm.com/forums">论坛</a>
        <a href="https://fc.osredm.com/competitions">竞赛</a>
        <router-link to="/admin">管理</router-link>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "JsonTools",
  data(){ return{ nativeCode:'', formatCode:'',
    mx:0, my:0, logo:require("@/assets/logo/osredm-logo-black-new.png"), logoWhite:require("@/assets/logo/osredmLogo-white.svg"),
    navElastic:{}, lastScrollY:0, rafId:0, navTiltStyle:{},
  }},
  methods:{
    Format(){ this.formatCode = JSON.parse(this.nativeCode) },
    backHome(){ this.$router.push('/'); },
    onMove(e){ this.mx=(e.clientX/window.innerWidth-0.5); this.my=(e.clientY/window.innerHeight-0.5); },
    navTilt(e){var r=this.$el.querySelector('.nav-bar');var x=(e.clientX-r.getBoundingClientRect().left)/r.offsetWidth-0.5;var y=(e.clientY-r.getBoundingClientRect().top)/r.offsetHeight-0.5;this.navTiltStyle={transform:'translateX(-50%) perspective(600px) rotateX('+(-y*8)+'deg) rotateY('+(x*8)+'deg)',transition:'transform 0.15s cubic-bezier(0.16,0.1,0.1,0.99)'};},navTiltReset(){this.navTiltStyle={transform:'translateX(-50%) perspective(600px) rotateX(0) rotateY(0)',transition:'transform 0.5s cubic-bezier(0.18,1.5,0.4,1)'};},
    onScroll(){var s=window.scrollY;var d=s-this.lastScrollY;var absD=Math.abs(d);this.lastScrollY=s;var sy=1+Math.min(absD*0.002,0.1);var ty=d>0?Math.min(absD*0.2,12):Math.max(d*0.2,-12);this.navElastic={transform:'translateX(-50%) scaleY('+sy+') translateY('+ty+'px)',transition:'none'};cancelAnimationFrame(this.rafId);this.rafId=requestAnimationFrame(()=>{this.navElastic={transform:'translateX(-50%) scaleY(1) translateY(0px)',transition:'transform 0.5s cubic-bezier(0.18,1.5,0.4,1)'};});},
  },
  mounted(){window.addEventListener('scroll',this.onScroll,{passive:true});},
  beforeDestroy(){window.removeEventListener('scroll',this.onScroll);cancelAnimationFrame(this.rafId);},
}
</script>

<style scoped>

.page { min-height:100vh; color:#1a1744; position:relative; overflow-x:hidden; background:#f8f7fd; padding-top:92px; box-sizing:border-box; }
.bg-grid { position:fixed; inset:0; z-index:0; pointer-events:none; opacity:0.03; background-image:linear-gradient(rgba(65,84,241,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(65,84,241,0.5) 1px, transparent 1px); background-size:40px 40px; mask-image:radial-gradient(ellipse 80% 60% at 50% 30%, black 30%, transparent 70%); -webkit-mask-image:radial-gradient(ellipse 80% 60% at 50% 30%, black 30%, transparent 70%); }
.amb { position:fixed; border-radius:50%; filter:blur(160px); pointer-events:none; z-index:0; opacity:0.6; }
.a1 { width:800px;height:800px; background:radial-gradient(circle, rgba(65,84,241,0.12), transparent 55%); top:-25%; left:-15%; animation:amb1 20s ease-in-out infinite; }
.a2 { width:600px;height:600px; background:radial-gradient(circle, rgba(0,200,232,0.09), transparent 55%); bottom:-18%; right:-12%; animation:amb2 24s ease-in-out 3s infinite; }
.a3 { width:450px;height:450px; background:radial-gradient(circle, rgba(139,92,246,0.07), transparent 55%); top:40%; left:50%; animation:amb1 18s ease-in-out 7s infinite; }
@keyframes amb1 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(30px,-12px) scale(1.06)} }
@keyframes amb2 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(-20px,12px) scale(1.05)} }
.ring { position:fixed; border-radius:50%; border:2px solid; pointer-events:none; z-index:0; opacity:0.08; animation:rFloat 16s ease-in-out infinite; }
.r1 { width:280px;height:280px; border-color:rgba(65,84,241,0.5); top:12%; left:4%; }
.r2 { width:200px;height:200px; border-color:rgba(0,200,232,0.4); bottom:18%; right:6%; animation-delay:6s; }
@keyframes rFloat { 0%,100%{transform:translate(0,0) rotate(0deg)} 50%{transform:translate(12px,-6px) rotate(18deg)} }
.dots { position:fixed; inset:0; z-index:0; pointer-events:none; opacity:0.3; background-image:radial-gradient(1.5px 1.5px at 12% 22%, rgba(65,84,241,0.4), transparent),radial-gradient(1px 1px at 38% 55%, rgba(0,200,232,0.35), transparent),radial-gradient(1.5px 1.5px at 62% 18%, rgba(139,92,246,0.35), transparent),radial-gradient(1px 1px at 78% 60%, rgba(65,84,241,0.3), transparent),radial-gradient(1.5px 1.5px at 85% 30%, rgba(0,200,232,0.35), transparent),radial-gradient(1px 1px at 20% 78%, rgba(245,158,11,0.25), transparent),radial-gradient(1.5px 1.5px at 48% 85%, rgba(139,92,246,0.3), transparent),radial-gradient(1px 1px at 92% 10%, rgba(65,84,241,0.3), transparent); background-size:200px 200px; animation:dots 28s linear infinite; }
@keyframes dots { 0%{background-position:0 0} 100%{background-position:200px 200px} }

.nav-bar{ position:fixed; top:12px; left:50%; transform:translateX(-50%); z-index:100; width:min(100% - 24px, 1400px); height:64px; display:flex; text-align:center; align-items:center; font-weight:600; padding:0 28px; border-radius:24px; will-change:transform;
  background:rgba(255,255,255,0.45); backdrop-filter:blur(14px) saturate(200%) brightness(1.08) contrast(1.04); -webkit-backdrop-filter:blur(14px) saturate(200%) brightness(1.08) contrast(1.04);
  border:1px solid rgba(255,255,255,0.5);
  box-shadow:0 0.5px 0 rgba(255,255,255,0.6) inset, 0 1px 2px rgba(255,255,255,0.4), 0 4px 14px rgba(0,0,0,0.03), 0 8px 28px rgba(65,84,241,0.05), 0 0 0 1px rgba(65,84,241,0.02); }
.nav-bar::before{ content:''; position:absolute; inset:-12px; border-radius:36px; pointer-events:auto; z-index:-1; }
.nav-bar:hover{ border-color:rgba(65,84,241,0.15); box-shadow:0 0.5px 0 rgba(255,255,255,0.7) inset, 0 1px 2px rgba(255,255,255,0.5), 0 4px 14px rgba(0,0,0,0.04), 0 8px 28px rgba(65,84,241,0.12), 0 0 0 1px rgba(65,84,241,0.08), 0 0 60px rgba(65,84,241,0.1); }
.nav-logo{ margin-left:20px; margin-right:44px; width:auto; height:34px; cursor:pointer; }
.nav-f{ margin-left:20px; color:var(--text-nav); text-decoration:none; }
.nav-f:hover{ color:var(--accent-soft); }
.nav-s{ margin-left:56px; color:var(--text-nav); text-decoration:none; }
.nav-s:hover{ color:var(--accent-soft); }
.nav-back{ margin-left:auto; color:var(--accent-soft); text-decoration:none; font-size:13px; font-weight:600; padding:8px 18px; border-radius:20px; background:var(--btn-glass-bg); border:1px solid var(--btn-glass-border); transition:all 0.3s; white-space:nowrap; }
.nav-back:hover{ background:var(--bg-card-hover); }

.hero { text-align:center; padding:48px 24px 32px; }
.hero-icon { width:72px; height:72px; display:block; margin:0 auto 16px; filter:drop-shadow(0 8px 24px rgba(65,84,241,0.15)); }
.hero h1 { font-size:32px; font-weight:800; margin:0 0 8px; letter-spacing:-0.02em; background:linear-gradient(135deg, #1a1744 30%, #4154f1); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; }
.hero p { font-size:15px; color:#6b6990; margin:0; }

.main { width:min(100%, 1100px); margin:0 auto; padding:0 24px 80px; box-sizing:border-box; }
.card { background:#fff; border-radius:20px; padding:28px 32px; box-shadow:0 2px 8px rgba(65,84,241,0.03), 0 8px 32px rgba(65,84,241,0.04); border:1px solid rgba(65,84,241,0.04); }
.panels { display:grid; grid-template-columns:1fr 1fr; gap:20px; margin-bottom:20px; }
.panel { min-width:0; }
.panel-head { font-size:13px; font-weight:700; color:#1a1744; margin-bottom:10px; display:flex; align-items:center; gap:8px; }
.ph-dot { width:8px;height:8px;border-radius:50%;background:#c8c6d8; flex-shrink:0; }
.ph-dot.done { background:#4154f1; box-shadow:0 0 6px rgba(65,84,241,0.4); }
.actions { display:flex; gap:12px; justify-content:flex-end; }
.btn-main { padding:12px 32px !important; font-size:14px !important; font-weight:700 !important; border-radius:28px !important; background:linear-gradient(135deg, #4154f1, #6366f1) !important; border:none !important; height:auto !important; }
.btn-main:hover { box-shadow:0 0 28px rgba(65,84,241,0.4) !important; transform:translateY(-1px); }

::v-deep .el-textarea__inner { font-family:'Fira Code','Consolas',monospace; background:#faf9fd; border:1px solid rgba(65,84,241,0.06); border-radius:12px; color:#1a1744; font-size:13.5px; line-height:1.6; padding:14px; resize:vertical; }
::v-deep .el-textarea__inner:focus { border-color:rgba(65,84,241,0.25); box-shadow:0 0 0 3px rgba(65,84,241,0.04); background:#fff; }
::v-deep .jv-code { background:#faf9fd !important; border-radius:12px !important; padding:14px !important; }

.foot { position:relative; z-index:2; margin-top:60px; background:#0f0c22; overflow:hidden; text-align:center; }
.foot-glow { position:absolute; top:0; left:50%; transform:translateX(-50%); width:600px; height:300px; border-radius:50%; background:radial-gradient(ellipse at center, rgba(65,84,241,0.15), transparent 70%); pointer-events:none; }
.foot-top { max-width:1100px; margin:0 auto; padding:44px 24px 32px; position:relative; }
.foot-logo { height:34px; width:auto; margin:0 auto 10px; object-fit:contain; }
.foot-desc { font-family:'Alibaba', sans-serif; font-size:17px; font-weight:700; color:rgba(255,255,255,0.6); letter-spacing:0.08em; margin:0 0 18px; }
.foot-links { display:flex; justify-content:center; flex-wrap:wrap; gap:8px 26px; }
.foot-links a { font-size:13.5px; font-weight:500; color:rgba(255,255,255,0.7); text-decoration:none; padding:4px 0; position:relative; transition:color 0.25s, text-shadow 0.25s; }
.foot-links a::after { content:''; position:absolute; left:50%; bottom:0; width:0; height:1.5px; border-radius:1px; background:linear-gradient(90deg, transparent, #fff, transparent); transform:translateX(-50%); transition:width 0.35s cubic-bezier(0.25,0.8,0.25,1.4); }
.foot-links a:hover { color:#fff; text-shadow:0 0 12px rgba(255,255,255,0.5); }
.foot-links a:hover::after { width:100%; }
.foot-bar { margin-top:14px; padding:14px 24px; border-top:1px solid rgba(255,255,255,0.08); display:flex; align-items:center; justify-content:center; gap:14px; font-size:11px; font-weight:400; letter-spacing:0.04em; color:rgba(255,255,255,0.35); position:relative; }
.foot-bar a { color:rgba(255,255,255,0.55); text-decoration:none; transition:color 0.2s; }
.foot-bar a:hover { color:#fff; }

@media(max-width:768px){
  .page { padding-top:72px; }
  .amb,.ring,.bg-grid,.dots { display:none; }
  .nav-bar { top:8px; width:calc(100% - 16px); height:50px; padding:0 12px; border-radius:18px; flex-wrap:nowrap; overflow:hidden; backdrop-filter:blur(12px) saturate(190%); -webkit-backdrop-filter:blur(12px) saturate(190%); }
  .nav-f,.nav-s { display:none; }
  .nav-back { font-size:10px; padding:5px 10px; }
  .nav-logo { height:22px; margin-right:12px; margin-left:4px; }
  .hero { padding:28px 16px 20px; }
  .hero h1 { font-size:24px; }
  .hero-icon { width:52px;height:52px; }
  .main { padding:0 12px 50px; }
  .card { padding:18px 14px; }
  .panels { grid-template-columns:1fr; }
  .actions { flex-direction:column; }
  .btn-main { width:100%; text-align:center; }
  .foot { margin-top:40px; }
  .foot-top { padding:32px 16px 24px; }
  .foot-links { gap:6px 18px; }
  .foot-links a { font-size:12px; }
  .foot-bar { flex-wrap:wrap; gap:10px; padding:14px 16px; font-size:10px; letter-spacing:0.04em; }
}

@media (prefers-reduced-motion: reduce) { .nav-bar{ animation:none !important; transition:none !important; } }
</style>
